import * as React from 'react';
import Pagination from '@/migration/pagination';
import { Loader } from 'semantic-ui-react';
import { MyProfileHeader, SalesList, TitleBar } from '@/components/Common';
import enhance from './enhance';

function ExhibitOfSeriNow(props) {
  const {
    isLoading,
    onChangePage,
    sales: {
      mypage: { totalCount, current, pages },
      ownExhibits,
    },
    isPaginationDisabled,
    users,
  } = props;

  // closedReasonが2の人を取り除く
  const auctionPage = pages.active.filter((page) => {
    return page.closedReason !== 2;
  });

  return (
    <div>
      <MyProfileHeader
        selledCount={ownExhibits.totalCount}
        userName={users.mydata.displayName}
        userThumbnail={users.mydata.thumnailImageUrl}
        averagePoint={users.mydata.averagePoint}
        totalEvaluationCount={users.mydata.totalEvaluationCount}
      />
      <TitleBar title="出品した商品 (オークション中)" />
      <div className="common_sales_list">
        {isLoading ? (
          <Loader
            className="tiny-loader"
            active
            size="tiny"
            inline="centered"
          />
        ) : (
          <>
            {auctionPage.length === 0 ? (
              <div
                style={{
                  textAlign: 'center',
                  paddingBottom: '40px',
                }}
              >
                <div>出品した商品 (オークション中) は存在しません</div>
              </div>
            ) : (
              <>
                <SalesList data={auctionPage} me={users.mydata} />
                <Pagination
                  totalCount={totalCount}
                  current={current}
                  pageSize={15}
                  changePage={onChangePage}
                  disabled={isPaginationDisabled}
                />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default enhance((props) => <ExhibitOfSeriNow {...props} />);
